import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '../internal/variants.js';
export function WeakestLinkBanner({ tone = 'attest', children }) {
    return (_jsxs("div", { className: cx('weak', tone === 'flag' && 'brick'), role: "note", children: [_jsxs("span", { className: "wl", children: ["weakest", _jsx("br", {}), "link"] }), _jsx("span", { className: "wt", children: children })] }));
}
//# sourceMappingURL=WeakestLinkBanner.js.map